module.exports = __webpack_public_path__ + "static/i8-741aa55dbc354c2cb24e4cd1a06e2f93.jpg";